/** Custom validators for Handsontable v16 */
import type Handsontable from 'handsontable-v16';
import {
  textMetadataInVivoValidator,
  dateMetadataInVivoValidator,
  numberMetadataInVivoValidator,
  fromInVivoValidator,
} from '@/support/hotValidator.util';

export const validatorsV16 = {
  metadata: {
    text: 'in-vivo-text-metadata',
    date: 'in-vivo-date-metadata',
    number: 'in-vivo-number-metadata',
  },
} as const;

type ValidatorFn = (this: unknown, value: unknown, callback: (valid: boolean) => void) => void;

export const registerCustomValidatorsV16 = (HandsontableInstance: typeof Handsontable): void => {
  HandsontableInstance.validators.registerValidator(
    validatorsV16.metadata.text,
    fromInVivoValidator(textMetadataInVivoValidator) as ValidatorFn
  );
  HandsontableInstance.validators.registerValidator(
    validatorsV16.metadata.date,
    fromInVivoValidator(dateMetadataInVivoValidator) as ValidatorFn
  );
  HandsontableInstance.validators.registerValidator(
    validatorsV16.metadata.number,
    fromInVivoValidator(numberMetadataInVivoValidator) as ValidatorFn
  );
};
